import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * @param {string} text — що показуємо і копіюємо
 * @param {string} [copyValue] — якщо задано, у буфер іде воно (напр. IBAN без пробілів)
 * @param {"corner"|"center"} [buttonPosition] — corner: як у заявах (правий верх); center — по центру блоку при наведенні
 */
const CopyOnHover = ({ text, copyValue, buttonPosition = "corner" }) => {
    const [copied, setCopied] = useState(false);
    const [hovered, setHovered] = useState(false);

    const display = text == null ? "" : String(text);
    const trimmed = display.trim();
    if (!trimmed) {
        return <span className="text-muted">—</span>;
    }

    const toCopy = copyValue != null ? String(copyValue) : display;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(toCopy);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error("Не вдалося скопіювати:", err);
        }
    };

    const btnClass =
        buttonPosition === "center"
            ? "position-absolute top-50 start-50 translate-middle"
            : "position-absolute top-0 end-0";

    return (
        <div
            className="position-relative"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => {
                setHovered(false);
                setCopied(false);
            }}
            style={{ minHeight: "24px" }}
        >
            <span style={{ opacity: buttonPosition === "center" && hovered ? 0.35 : 1 }}>
                {display}
            </span>
            {hovered && (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{copied ? "Скопійовано!" : "Скопіювати"}</Tooltip>}
                >
                    <Button
                        variant="link"
                        className={`${btnClass} p-0 border-0 shadow-none text-decoration-none text-secondary lh-1`}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCopy();
                        }}
                        style={{ fontSize: "0.95rem", zIndex: 2, minWidth: 0 }}
                    >
                        📋
                    </Button>
                </OverlayTrigger>
            )}
        </div>
    );
};

export default CopyOnHover;
